import { style } from '@angular/animations';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
import { TemplateConfig } from '@rxweb/grid';

export const DOWNLOAD_DOC_LINK_GRID_TEMPLATE: TemplateConfig = {
    div: {
        class: [
            function (e) {
                return "divTableCell".split(" ");
            }],
        attributes: {
            'data-head': function (e) { return e.headerTitle; }
        }
        ,
        childrens: [{
            div: {
                childrens: [{
                    a: {
                        event: {
                            click: "downloadLink"
                        },
                        childrens: [{
                            div: {
                                style: {
                                    // "text-decoration":"underline",
                                    "cursor": "pointer",
                                },
                                //class:["mb-0 badge sucess"],
                                childrens: [{
                                    text: {
                                        text: function (e) {
                                            if (this[e.name] != null) {
                                                return this[e.name];
                                            } else {
                                                return ''
                                            }
                                        }
                                    },
                                    i: { class: 'fas fa-download'.split(' '), style: { 'margin-left': '6px' , 'color':'#148ab8' } }
                                }]
                            }
                        }]
                    }
                }],
            }
        }]
    }
};
